import { Component } from '@angular/core';
import { ProfileComponent as PortfolioComponent } from './portfolio.component';

@Component({
  selector: 'eid-portfolio-desktop',
  templateUrl: './portfolio.desktop.component.html',
  styleUrls: ['./portfolio.desktop.component.scss']
})
export class PortfolioDesktopComponent extends PortfolioComponent {}
